const classes = {
  hide: 'hide',
};

export { classes };
